module.exports = __webpack_public_path__ + "img/win.f3ddb14b.svg";